import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4da46eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-text-right mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "field has-text-right"
}
const _hoisted_3 = { class: "control" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["for"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help all-models-help is-pulled-right mb-2" }, "By default, only models compatible with the selected worker are shown.", -1))
const _hoisted_7 = {
  key: 1,
  class: "tabs is-centered mb-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Available models", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Archived models", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "control" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = { class: "table is-fullwidth is-hoverable" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name")
  ])
], -1))
const _hoisted_16 = ["onClick", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateForm = _resolveComponent("CreateForm")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CreateForm, {
        mode: "create",
        onReload: _ctx.updateModelsPage
      }, null, 8, ["onReload"])
    ]),
    (_ctx.compatibleWorkerId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              id: `allModelsToggle${_ctx.uid}`,
              type: "checkbox",
              class: "switch is-rounded is-info",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.allModels) = $event))
            }, null, 8, _hoisted_4), [
              [_vModelCheckbox, _ctx.allModels]
            ]),
            _createElementVNode("label", {
              for: `allModelsToggle${_ctx.uid}`
            }, "Show all models", 8, _hoisted_5)
          ]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    (_ctx.showArchived)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': !_ctx.archivedModels }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.archivedModels = false))
            }, _hoisted_9, 2),
            _createElementVNode("li", {
              class: _normalizeClass({ 'is-active': _ctx.archivedModels }),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.archivedModels = true))
            }, _hoisted_11, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modelsPage)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "field",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filter && _ctx.filter(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nameFilter) = $event)),
              placeholder: "Filter by name…"
            }, null, 512), [
              [_vModelText, _ctx.nameFilter]
            ])
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Paginator, {
        response: _ctx.modelsPage,
        loading: _ctx.loading,
        page: _ctx.page,
        "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page) = $event)),
        singular: "model",
        plural: "models"
      }, {
        default: _withCtx(({ results }) => [
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results, (model) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: model.id,
                  onClick: ($event: any) => (_ctx.$emit('update:modelValue', model.id)),
                  class: _normalizeClass(["is-clickable", { 'is-selected': _ctx.modelValue === model.id }]),
                  title: model.name
                }, [
                  _createElementVNode("td", null, _toDisplayString(_ctx.truncateLong(model.name)), 1)
                ], 10, _hoisted_16))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["response", "loading", "page"])
    ])
  ], 64))
}